import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import SensorsIcon from '@mui/icons-material/Sensors';
import { useTranslation } from 'react-i18next';

/**
 * Aggregate type selector button and menu.
 * @param {Object} props
 * @param {string|null} props.aggregateOverride - Current override value
 * @param {Array<string>} props.options - List of aggregate options
 * @param {Function} props.onChange - Callback when selection changes
 * @param {Function} props.getAggregateType - Function to determine if option is selectable
 * @param {Object} props.dateRange - { from, to }
 */
const AggregateTypeSelector = ({
  aggregateOverride,
  options,
  onChange,
  getAggregateType,
  dateRange,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation('view-data');
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<SensorsIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {aggregateOverride ?? 'Auto'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          selected={aggregateOverride === null}
          onClick={() => {
            onChange(null);
            setAnchorEl(null);
          }}
        >
          Auto
        </MenuItem>
        {options.map((opt) => (
          <MenuItem
            key={opt}
            disabled={
              getAggregateType({ ...dateRange, requested: opt }) !== opt
            }
            selected={aggregateOverride === opt}
            onClick={() => {
              onChange(opt);
              setAnchorEl(null);
            }}
          >
            {t(`aggregate.${opt}`) || opt}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default AggregateTypeSelector;
